import React from "react"
import Wrapper from "@components/Wrapper"
import WrapperInner from "@components/WrapperInner"
import TopTitle from "@components/TopTitle"
import styles from "./ProblemStatement.module.scss"

const ProblemStatement = props => {
  return (
    <section className={styles.section + " container-fluid bg-xl-light-gray"}>
      <div className="row ml-0 mr-0">
        <Wrapper className="w-100" gap="outer">
          <WrapperInner className={styles.wrapperInner + " row"}>
            <div className="col-12">
              <div
                className={
                  styles.introContent + " text-white text-center m-auto"
                }
              >
                <h3>
                  <TopTitle content="WHY NOW IS THE RIGHT TIME TO" />
                  <div className="proxima-nova--extra-bold fs-30pt fs-lg-40pt fs-xl-50pt mb-4">
                    CONTROL IDENTITY AND ACCESS MANAGEMENT — YOUR WAY
                  </div>
                </h3>
                <p
                  className={
                    styles.description +
                    " proxima-nova--light fs-18pt fs-xl-22pt"
                  }
                >
                  Is the lack of security and control over your employees’
                  access to applications causing problems for the business?
                  Could it be leading to:
                </p>
              </div>
            </div>
            <div className="col-12 text-secondary">
              <ul
                className={
                  styles.list +
                  " proxima-nova--semi-bold fs-16pt fs-lg-18pt fs-xl-21pt"
                }
              >
                <li>
                  A loss of productivity when employees forget their passwords
                  again?
                </li>
                <li>
                  An increase in requests to the help desk/IT department to
                  reset passwords?
                </li>
                <li>
                  Staff who are frustrated by the repetitive task of entering
                  their login and password details for their numerous work apps?
                </li>
                <li>
                  Increased security risks to your company due to multiple,
                  uncontrolled user identities spread across different apps?
                </li>
                <li>
                  A potential security breach because employees are writing down
                  passwords?
                </li>
                <li>
                  Complex accountability measures to ensure there are no
                  information or data security breaches?
                </li>
                <li>
                  A time-consuming onboarding process for new employees that
                  involves setting up numerous applications one by one?
                </li>
              </ul>
            </div>
          </WrapperInner>
        </Wrapper>
      </div>
    </section>
  )
}

export default ProblemStatement
